
const Heading = {
    
    variants: {
      solid: {
        fontFamily: "Gilroy - 900",
        fontSize: "67px",
        fontWeight: "900",
        lineHeight:"81px",
        // textAlign:"ri",
        
        
      },
      outline: {
        fontFamily: "Gilroy - 700",
        fontSize: "38px",
        fontWeight: "700",
        lineHeight:"53px",
        color:"#0b3558",
        fontStyle:"normal"
        
        
      },
      ghost: {
        fontFamily: "Gilroy - 900",
        fontSize: "40px",
        fontWeight: "900",
        lineHeight:"60px",
        color:"#0b3558"
      },
      smooth: {
        fontFamily: "DM Sans - 600",
        fontSize: "22px",
        fontWeight: "600",
        fontStyle:"normal"
        
      },
      normal: {
        fontFamily: "Montserrat - 700",
        fontSize: "30px",
        fontWeight: "700",
        fontStyle:"normal",
        textAlign:"center"
        
      },
      
    },
  };
  export default Heading;